import { Injectable } from "@angular/core";
import { IPRFIListItem } from "../api-generated";
import BaseService from "./base.service";

@Injectable({
  providedIn: "root",
})
export default class LocalRFIItemService extends BaseService<IPRFIListItem> {
  public firstLoad = false;
  public nestedView: boolean = true;
}
